import CustomPaginate from './CustomPaginate';

export default CustomPaginate;